export const version = {
    appVersion: '2.6.0',
    buildDate: '2026-7-29 12:43:21'
}